<div class="selection-list">
  <ul class="selection-list__items">

    <ng-container *ngFor="let item of selectionItems">

      <lds-tooltip [message]="item.disabled ? (item.disabledTooltip || 'Presently Unavailable') : item.name"
                   [showDelay]="1500">
        <li class="selection-list__item"
            [ngClass]="{ 'selection-list__item--disabled': item.disabled }"
            [attr.data-testid]="item.name"
            (click)="onItemClick(item)">

          <div class="selection-list__icon">
            <lds-icon [name]="item.icon"
                      size="md"
                      appearance="inherit"></lds-icon>
          </div>
          <div class="selection-list__label">
            {{ item.name }}
            <lds-tooltip message="{{ item.hint }}"
                          placement="bottom"
                          cursor="help"
                          *ngIf="item.hint">
              <lds-icon name="info"
                        size="xs"
                        appearance="inherit"></lds-icon>
            </lds-tooltip>
          </div>

        </li>
      </lds-tooltip>

    </ng-container>

  </ul>
</div>